import type { NewsItem } from "../types";

export function isTruthyFlag(value: unknown): boolean {
    return value === true || value === "true" || value === 1;
}

/** Whether an active news item is visible on the order app for `schoolKey`. */
export function isNewsItemForSchool(item: NewsItem, schoolKey: string): boolean {
    if (item.isActive === false) {
        return false;
    }
    if (isTruthyFlag(item.allSchools)) {
        return true;
    }
    return isTruthyFlag(item.schools?.[schoolKey]);
}
